import { useState, useEffect, useContext } from "react";

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");

  // Helper function to decode the token
  const decodeToken = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const decoded = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(decoded);
    } catch (error) {
      return null;
    }
  };

  const checkTokenValidity = () => {
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    // Decode the token to get the expiration time
    const decodedToken = decodeToken(token);

    if (!decodedToken || !decodedToken.exp) {
      setIsAuthenticated(false);
      return;
    }

    // Check if the token is still valid (not expired)
    const currentTime = Math.floor(Date.now() / 1000);
    if (decodedToken?.exp < currentTime) {
      setIsAuthenticated(false);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } else {
      setIsAuthenticated(true);
      setRole(user?.role);
    }
  };

  useEffect(() => {
    checkTokenValidity();
  }, [user]);
  return { isAuthenticated, role };
};

export default useAuth;
